import type { ErrorCopy } from '@shared/errors/catalog';

import { contentAndAssetsErrors } from '../_shared/errors';

/**
 * The codes this surface meets — the content catalogue for the title itself and
 * the assets catalogue for the cover upload, because authoring writes to both
 * services in one flow.
 *
 * The two that matter most here are the provider failures: both say the same
 * thing in different words, and both say it as a **next step** rather than as a
 * failure — fill the form by hand, because enrichment is an accelerator and
 * never a condition of publishing.
 */
export const errors: Readonly<Record<string, ErrorCopy>> = contentAndAssetsErrors;
